import * as sanitizeHtml from "sanitize-html";

export function assume(x: boolean): asserts x {
}

export async function copyTextToClipboard(text: string) {
    if (!navigator.clipboard)
        return;
    await navigator.clipboard.writeText(text);
}

export function removeAllChildren(node: Node) {
    const list = node.childNodes;
    for (var i = list.length - 1; i >= 0; i--) {
        if (list[i] && list[i].parentElement) {
            list[i].parentElement.removeChild(list[i]);
        }
    }
}

export function canvasToBlob(canvas: HTMLCanvasElement) {
    return new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(blob => {
            resolve(blob);
        });
    });
}

export function downloadBlob(blob: Blob, name: string) {
    const url = URL.createObjectURL(blob);

    const tmpLink = document.createElement("a");
    tmpLink.style.display = "none";
    tmpLink.href = url;
    tmpLink.download = name;
    document.body.appendChild(tmpLink);
    tmpLink.click();
    document.body.removeChild(tmpLink);
    URL.revokeObjectURL(url);
}

export function getRandomInt(b: number) {
    return Math.floor(Math.random() * b);
}

// Process [link](href) in string, sanitize everything, don't do much else. 
export function redneckMd(text: string) {
    const linksRegex = /\[(.+?)\]\s*\((.+?)\)/g;
    const dirtyHtml = text
        .replace(linksRegex, (match, link, href) => `<a href=\"${href}\">${link}</a>`)
        .replace('\n', "<br>");
    return sanitizeHtml(dirtyHtml, {
        allowedTags: ['a', 'br'],
        allowedAttributes: {
            'a': ['href']
        },
        allowedIframeHostnames: []
    });
}

export function merge(from: any, into: any) {
    for (const key in from) {
        if (typeof from[key] == "object" && key in into && !(from[key] instanceof Array)) {
            if (typeof into[key] != "object") continue;

            merge(from[key], into[key]);
        } else {
            if (key in into) continue;

            into[key] = from[key];
        }
    }
}